import axios, { AxiosError, AxiosResponse } from 'axios';

const ADRESSE_API_BASE_URL = 'https://api-adresse.data.gouv.fr';

export interface Coordinates {
    lat: number;
    lon: number;
}

interface AdresseDataGouvFeature {
    geometry: {
        coordinates: [number, number];
    };
    properties: {
        label: string;
        score: number;
    };
}

interface AdresseDataGouvResponse {
    features: AdresseDataGouvFeature[];
}

export const getCoordsFromAddress = async (address: string, minScore: number = 0.5): Promise<Coordinates | null> => {
    if (!address || address.trim() === '') {
        console.warn('Adresse vide fournie au service de géolocalisation');
        return null;
    }

    try {
        const response: AxiosResponse<AdresseDataGouvResponse> = await axios.get(`${ADRESSE_API_BASE_URL}/search/`, {
            params: {
                q: address,
                limit: 1,
            },
            timeout: 5000,
        });

        const features = response.data.features;

        if (features && features.length > 0) {
            const feature = features[0];
            const score = feature.properties.score;

            if (score < minScore) {
                console.warn(`Score de confiance trop faible (${score}) pour l'adresse: ${address}`);
                return null;
            }

            const [lon, lat] = feature.geometry.coordinates;
            return { lat, lon };
        }

        console.warn(`Aucune coordonnée trouvée pour l'adresse: ${address}`);
        return null;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message || 'Erreur API adresse.data.gouv. fr');
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const batchGeocodeAddresses = async (addresses: string[]): Promise<(Coordinates | null)[]> => {
    const promises = addresses.map((address) => getCoordsFromAddress(address));
    return Promise.all(promises);
};
